import { createFileRoute } from '@tanstack/react-router'
import { Home } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { AddonsPage } from '@/features/addons'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/shared/components/ui/breadcrumb'
import { useBreadcrumbs } from '@/shared/hooks/useBreadcrumbs'

export const Route = createFileRoute('/_auth/catalog/addons/')({
  component: CatalogAddonsPage,
})

function CatalogAddonsPage() {
  const { setBreadcrumbs } = useBreadcrumbs()

  const breadcrumbsContent = useMemo(
    () => (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink to='/dashboard' className='flex items-center gap-1'>
              <Home className='w-4 h-4' />
              Dashboard
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Catalog</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Addons</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    ),
    []
  )

  useEffect(() => {
    setBreadcrumbs(breadcrumbsContent)
  }, [setBreadcrumbs, breadcrumbsContent])

  return (
    <div className='container mx-auto py-6'>
      <AddonsPage />
    </div>
  )
}
